// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__iqT7c","inner":"tooltip_inner__26nhe","touch":"tooltip_touch__3fILu"};